export const NextArrow = () => (
    <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.13867 12.2797L5.48534 7.93306C5.99867 7.41973 5.99867 6.57973 5.48534 6.06639L1.13867 1.71973" stroke="white" style={{ stroke: 'white', strokeOpacity: 1 }} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);


